import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
import { useLayoutBreakpoint } from '@/composables/useLayoutBreakpoint';
import AppBottomSheet from '@/components/shell/AppBottomSheet.vue';
export default {
  __name: 'PmDialogShell',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    showHandle: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: false
    },
    sheetClass: {
      type: String,
      default: ''
    },
    modalClass: {
      type: String,
      default: ''
    },
    dialogClass: {
      type: String,
      default: ''
    },
    dialogWidth: {
      type: [String, Number],
      default: '500px'
    },
    alignCenter: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: undefined
    },
    /** 跳过弹层，直接内嵌 slot（桌面详情右侧交易面板） */
    inline: {
      type: Boolean,
      default: false
    },
    /** 移动端也走居中 el-dialog（浮动卡片，非底栏 sheet） */
    forceDialog: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'closed'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      isMobile
    } = useLayoutBreakpoint();
    function onVisibleChange(next) {
      emit('update:modelValue', next);
    }
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return __props.inline ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(__props.dialogClass)
      }, [_renderSlot(_ctx.$slots, "default"), _ctx.$slots.footer ? _renderSlot(_ctx.$slots, "footer", {}, undefined, undefined, 0) : _createCommentVNode("", true)], 2)) : _unref(isMobile) && !__props.forceDialog ? (_openBlock(), _createBlock(AppBottomSheet, {
        key: 1,
        "model-value": __props.modelValue,
        title: __props.title,
        "show-header": __props.showHeader,
        "show-handle": __props.showHandle,
        "show-close": __props.showClose,
        "sheet-class": __props.sheetClass,
        "modal-class": __props.modalClass,
        "close-on-click-modal": __props.closeOnClickModal,
        "close-on-press-escape": __props.closeOnPressEscape,
        "destroy-on-close": __props.destroyOnClose,
        "z-index": __props.zIndex,
        "onUpdate:modelValue": onVisibleChange,
        onClosed: _cache[0] || (_cache[0] = $event => _ctx.$emit('closed'))
      }, _createSlots({
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 2
      }, [_ctx.$slots.footer ? {
        name: "footer",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "footer")]),
        key: "0"
      } : undefined]), 1032, ["model-value", "title", "show-header", "show-handle", "show-close", "sheet-class", "modal-class", "close-on-click-modal", "close-on-press-escape", "destroy-on-close", "z-index"])) : (_openBlock(), _createBlock(_component_el_dialog, {
        key: 2,
        "model-value": __props.modelValue,
        class: _normalizeClass(__props.dialogClass),
        "modal-class": __props.modalClass,
        width: __props.dialogWidth,
        "show-close": __props.showClose,
        "align-center": __props.alignCenter,
        "append-to-body": __props.appendToBody,
        "destroy-on-close": __props.destroyOnClose,
        "close-on-click-modal": __props.closeOnClickModal,
        "close-on-press-escape": __props.closeOnPressEscape,
        "z-index": __props.zIndex,
        "onUpdate:modelValue": onVisibleChange,
        onClosed: _cache[1] || (_cache[1] = $event => _ctx.$emit('closed'))
      }, _createSlots({
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 2
      }, [_ctx.$slots.footer ? {
        name: "footer",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "footer")]),
        key: "0"
      } : undefined]), 1032, ["model-value", "class", "modal-class", "width", "show-close", "align-center", "append-to-body", "destroy-on-close", "close-on-click-modal", "close-on-press-escape", "z-index"]));
    };
  }
};